interface SearchModeToggleProps {
  currentMode: 'regular' | 'research';
  onModeChange: (mode: 'regular' | 'research') => void;
}

export function SearchModeToggle({ currentMode, onModeChange }: SearchModeToggleProps) {
  return (
    <div className="flex gap-2">
      <button
        onClick={() => onModeChange('regular')}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
          currentMode === 'regular'
            ? 'bg-zinc-900 text-white shadow-md'
            : 'bg-white text-zinc-700 border border-zinc-300 hover:bg-zinc-50'
        }`}
      >
        🔍 General Search
      </button>
      <button
        onClick={() => onModeChange('research')}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
          currentMode === 'research'
            ? 'bg-blue-600 text-white shadow-md'
            : 'bg-white text-zinc-700 border border-zinc-300 hover:bg-zinc-50'
        }`}
      >
        🔬 Research Mode
      </button>
    </div>
  );
}

export default SearchModeToggle;
